import { Vue } from 'vue-property-decorator';

import vuetify from '@/plugins/vuetify';

import RetryStickybeakDialog from '@/components/common/RetryStickybeakDialog.vue';

const RetryStickybeakDialogClass = Vue.extend(RetryStickybeakDialog);

export default function retryStickybeakDialog(
  itemName: string,
  confirmCode: string,
): Promise<boolean> {
  return new Promise(resolve => {
    const dialog = new RetryStickybeakDialogClass({
      vuetify,
      propsData: {
        itemName,
        confirmCode,
      },
    });
    dialog.$on('close', () => {
      dialog.$destroy();
      resolve(false);
    });
    dialog.$on('confirm', (confirm: boolean) => {
      dialog.$destroy();
      resolve(confirm);
    });
    dialog.$mount();
  });
}
